import AccountSync from "../services/AccountSync.js";
import MapExploration from "./MapExploration.js";

/**
 * Passeport (49 du TODO) : trois tampons par pays, gagnés dans tous les jeux.
 *
 * - drapeau : reconnu dans Flag Nerd, un Speed Run drapeaux ou un Défi du jour ;
 * - capitale : trouvée dans Capital Nerd (tous modes) ou un Défi du jour ;
 * - carte : situé dans Map Nerd, c'est-à-dire l'exploration déjà tenue par
 *   `MapExploration` (lue telle quelle, rien n'est recopié).
 *
 * Stocké sous `geonerd.passport` = `{ code: bits }`, commun aux deux langues et
 * synchronisé par union (un tampon gagné sur un appareil l'est partout). Un
 * objectif de collection : 193 pays à compléter, continent par continent.
 */
export const STAMPS = { flag: 1, capital: 2, map: 4 };
export const KEY = "geonerd.passport";

export function read() {
	try {
		const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
		return raw && typeof raw === "object" ? raw : {};
	} catch (e) {
		return {};
	}
}

/** Tampons d'un pays, carte comprise (déduite de l'exploration). */
export function stampsOf(code, passport = read(), discovered = MapExploration.getDiscovered()) {
	return (Number(passport[code]) | 0) | (discovered.has(code) ? STAMPS.map : 0);
}

/** Ajoute un tampon (idempotent). `kind` : "flag" | "capital". */
export function stamp(code, kind) {
	const bit = STAMPS[kind];
	if (!code || !bit || kind === "map") return;
	const passport = read();
	const before = Number(passport[code]) | 0;
	if (before & bit) return;
	passport[code] = before | bit;
	localStorage.setItem(KEY, JSON.stringify(passport));
	AccountSync.scheduleSync();
}

/**
 * Bilan pour une liste de pays : tampons par type et pays complets. Un pays
 * absent de la carte jouable (micro-États, `mapCodes`) est complet avec son
 * drapeau et sa capitale.
 */
export function summary(codes, mapCodes) {
	const passport = read();
	const discovered = MapExploration.getDiscovered();
	const result = { flag: 0, capital: 0, map: 0, complete: 0, total: codes.length, mapTotal: 0 };
	for (const code of codes) {
		const bits = stampsOf(code, passport, discovered);
		const onMap = mapCodes.has(code);
		if (onMap) result.mapTotal++;
		if (bits & STAMPS.flag) result.flag++;
		if (bits & STAMPS.capital) result.capital++;
		if (bits & STAMPS.map) result.map++;
		const needed = STAMPS.flag | STAMPS.capital | (onMap ? STAMPS.map : 0);
		if ((bits & needed) === needed) result.complete++;
	}
	return result;
}
